import {createEvent} from "effector";

export const setProjRegistryDataEv = createEvent()
export const resetProjRegFilteredStoreEv = createEvent()
